import React from 'react';

import AdwertImage from 'components/AdwertImage';
import Category from './Category';
import SearchAuthor from './SearchAuthor';


const LeftSide = props => {
  const { categories, banners } = props;
  return (
    <div className="left-bar-container">
      <SearchAuthor />
      <ul className="left-menu">
        <Category category={{ id: 'all', name: 'All' }} />
        {categories.map(category => (
          <Category key={category.id} category={category} />
        ))}
      </ul>

      {
        banners && banners.map(item => {
          return (<AdwertImage
            key={item.id}
            img={`${item.image}`}
            url={item.url} />);
        })
      }
    </div>
  );
}

export default LeftSide;